import type { PlayerMask, YTStateChangeEvent } from '../utils/VideoUtils';
import { includeYTScript } from '../utils/VideoUtils';

export default function initVideo() {
  Alpine.data('video', () => ({
    videoWrapper: null as HTMLElement | null,
    player: null as PlayerMask | null,
    playing: false,
    init(){
      this.videoWrapper = this.$el.querySelector('.video-player');
    },
    playVideo() {
      if (this.player) {
        this.player.playVideo();
        this.playing = true;
      } else if (this.videoWrapper) {
        const { videoId } = this.videoWrapper.dataset;
        includeYTScript();
        Alpine.effect(() => {
          if (Alpine.store('ytPlayerReady') && !this.player && this.videoWrapper) {
            this.player = new YT.Player(this.videoWrapper.id, {
              videoId,
              host: 'https://www.youtube-nocookie.com',
              playerVars: {
                'rel': 0,
              },
              events: {
                'onReady': () => this.onPlayerReady(),
                'onStateChange': (event: YTStateChangeEvent) => this.onPlayerStateChange(event),
              }
            });
          }
        });
      }
    },
    imageClasses() {
      return this.playing ? 'z-1 opacity-0' : 'z-2 opacity-100';
    },
    videoClasses() {
      return this.playing ? 'z-2 opacity-100' : 'z-1 opacity-0';
    },
    onPlayerReady() {
      if (this.player) {
        this.player.playVideo();
        this.playing = true;
      }
    },
    onPlayerStateChange(event: YTStateChangeEvent) {
      const { data } = event;
      if (data === YT.PlayerState.PAUSED || data === YT.PlayerState.ENDED) {
        this.playing = false;
      }
    },
  }));
}
